import React, { useEffect, useState } from "react";
import {
    Grid,
    Paper,
    Typography,
    Link as MuiLink,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
} from "@material-ui/core";
import ScheduleRoundedIcon from '@material-ui/icons/ScheduleRounded';
import CalendarTodayRoundedIcon from '@material-ui/icons/CalendarTodayRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { useStressEntryContext } from "./StressEntryContext";
import { ErrorOutline } from "@material-ui/icons";
import { useFetchContext } from "../../../common/FetchContext";
import { toast } from "react-toastify";
import { formatDate } from "../../../common/formatDate";
import { useGetCalibartionData } from "./stressEntryQueries";

export const CalibrationData = () => {

    const { state, dispatch } = useStressEntryContext();

    const [showCalibrationData, setShowCalibrationData] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [newDate, setNewDate] = useState("");
    const [reason, setReason] = useState("");


    const {
        data: calibrationDataResponse,
        error: calibrateDataError,
        isLoading: isLoadingcalibrateData,
        isError: isErrorcalibrateData,
        isSuccess: isSuccesscalibrateData,
    } = useGetCalibartionData(state.selectedStressType?.id);

    useEffect(() => {
        if (isErrorcalibrateData) {
            toast.error("Asset calibration data not found");
            console.error(calibrateDataError);
            dispatch({ type: "SET_CALIBRATION_READY", payload: false });
        }
        if (isSuccesscalibrateData && calibrationDataResponse) {
            dispatch({ type: "SET_ISCALIBRATED", payload: { calibrateInfo: calibrationDataResponse.is_calibration } });
            dispatch({ type: "SET_CALIBRATION_READY", payload: true });
        }
    }, [isErrorcalibrateData, isSuccesscalibrateData, calibrateDataError, calibrationDataResponse, dispatch]);

    if (isLoadingcalibrateData) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100px" }}>
                <CircularProgress />
            </Grid>
        );
    }

    // Determine if the asset is overdue based on calibration data
    const isOverdue = !(calibrationDataResponse?.is_calibration);

    const handleCalibrationdata = () => {
        setShowCalibrationData((prev) => !prev);
    };

    // 👉 Handle dialog open/close
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setNewDate("");
        setReason("");
    };

    const handleExtendSubmit = () => {
        if (!newDate) {
            toast.warning("Please select a new calibration date!");
            return;
        } else if (!reason) {
            toast.warning("Please enter a reason!");
            return;
        }
        toast.success(`Calibration extended to ${newDate}, ${reason}`);
        handleCloseDialog(); // 👈 also clears fields
    };

    return (
        calibrationDataResponse && (

            <>
                <Grid container direction="column" spacing={5} style={{ paddingRight: 24 }} >

                    <Grid container alignItems="center" justifyContent="space-between" style={{ paddingRight: 24 }}>

                        <Grid item>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="h6" style={{ fontSize: "26px", padding: 14 }}>
                                    Asset {state.selectedStressType.name}
                                </Typography>


                                <div
                                    style={{
                                        backgroundColor: isOverdue ? "#FEF3F2" : "#EFFDF4",
                                        padding: "3px 8px",
                                        border: `1px solid ${isOverdue ? "#FFCACA" : "#B9F8CF"}`,
                                        borderRadius: "100px",
                                        fontSize: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                        color: isOverdue ? "#FF0000" : "#008000",
                                    }}
                                >
                                    {isOverdue ? (
                                        <ErrorOutline fontSize="small" style={{ marginRight: 4 }} />
                                    ) : (
                                        <CheckCircleOutlineRoundedIcon fontSize="small" style={{ marginRight: 4 }} />
                                    )}
                                    {isOverdue ? "overdue" : "In Calibration"}
                                </div>

                            </div>
                        </Grid>


                        <Grid item>
                            <MuiLink
                                component="button"
                                variant="body2"
                                onClick={handleCalibrationdata}
                                style={{ marginTop: "4px", display: 'flex', alignItems: 'center', gap: '4px' }}
                            >
                                {showCalibrationData ? (<>Hide Calibration Details <ExpandLessIcon fontSize="small" /></>) : (<>
                                    Show Calibration Details <ExpandMoreIcon fontSize="small" />
                                </>)}
                            </MuiLink>
                        </Grid>

                        {
                            showCalibrationData && (
                                isOverdue ? (
                                    <Grid container spacing={2} style={{ padding: 14 }}>
                                        <Grid item xs={12}>
                                            <Paper
                                                elevation={0}

                                            >
                                                <Grid container spacing={2} style={{
                                                    border: "1px solid #FFCACA",
                                                    backgroundColor: "#FEF3F2",
                                                    padding: 10,
                                                    borderRadius: "10px"
                                                }}>

                                                    <Grid item xs={12} container alignItems="center">
                                                        <ErrorOutline style={{ color: "#FF0000", marginRight: 8 }} />
                                                        <Typography variant="h6" style={{ color: "#FF0000", fontWeight: 700 }}>
                                                            Calibration Overdue - Immediate Action Required
                                                        </Typography>
                                                    </Grid>


                                                    <Grid item xs={12}>
                                                        <Typography variant="body2" style={{ color: "#FF000094" }}>
                                                            <b> Asset {state.selectedStressType.name} </b> has exceeded its calibration due
                                                            date by <b> {calibrationDataResponse?.days_to_next_calibration} days</b>. This asset must be calibrated
                                                            immediately before it can be used for any testing or operations.
                                                            Please contact the calibration team to schedule an urgent
                                                            calibration service.
                                                        </Typography>
                                                    </Grid>


                                                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleOpenDialog}
                                                            style={{
                                                                backgroundColor: "#800280",
                                                                color: "#fff",


                                                            }}
                                                        >
                                                            EXTEND CALIBRATION
                                                        </Button>
                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                            <Grid item xs={12} container alignItems="center" style={{ marginTop: "15px" }}>
                                                <Typography variant="subtitle1" style={{ fontSize: "20px" }}>
                                                    Calibration Details
                                                </Typography>
                                                <Grid container spacing={4}>
                                                    <Grid item xs={12} md={4}>
                                                        <Paper
                                                            elevation={2}
                                                            style={{
                                                                paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px",
                                                                backgroundColor: "#FFFFFF",
                                                                border: "1px solid #E5E7EB",
                                                                height: "172px",
                                                                borderRadius: "10px"
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                color="secondary"
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <CalendarTodayRoundedIcon fontSize="small" style={{ marginRight: 4 }} />
                                                                Last Calibrated
                                                            </Typography>

                                                            <Typography
                                                                variant="h6"
                                                                style={{
                                                                    color: "#800280",
                                                                    fontWeight: "bold",
                                                                    fontSize: "24px", marginTop: "30px"
                                                                }}
                                                            >
                                                                {calibrationDataResponse?.last_calibrated_date
                                                                    ? formatDate(calibrationDataResponse.last_calibrated_date)
                                                                    : "--"}
                                                            </Typography>

                                                            <Typography variant="body2" color="textSecondary">
                                                                {calibrationDataResponse?.calibration_days} days ago
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>


                                                    <Grid item xs={12} md={4}>
                                                        <Paper
                                                            elevation={4}
                                                            style={{ paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#FEF3F2", border: "1px solid #FFCACA", height: "172px", borderRadius: "10px" }}
                                                        >
                                                            <Typography variant="body2" style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                color: "#FF0000"
                                                            }}>
                                                                <ScheduleRoundedIcon fontSize="small" style={{ marginRight: "5px" }} />
                                                                Next Calibration Due
                                                            </Typography>
                                                            <Typography variant="h6" style={{ color: "#FF0000", fontWeight: "bold", fontSize: "24px", marginTop: "30px" }}>
                                                                {calibrationDataResponse?.next_calibration_date
                                                                    ? formatDate(calibrationDataResponse.next_calibration_date,)
                                                                    : "--"}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                Calibration up to date
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <Paper
                                                            elevation={2}
                                                            style={{ paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#FFFFFF", border: "1px solid #FFCACA", height: "172px", borderRadius: "10px" }}
                                                        >
                                                            <Typography variant="body2" style={{
                                                                display: "flex",
                                                                alignItems: "center",

                                                            }} >
                                                                <ErrorOutline fontSize="small" style={{ marginRight: "5px", color: "#FF0000" }} />
                                                                Days to Next Calibration
                                                            </Typography>
                                                            <Typography variant="h6" style={{ color: "#FF0000", fontWeight: "bold", fontSize: "24px", marginTop: "30px" }}>
                                                                {calibrationDataResponse.days_to_next_calibration}
                                                            </Typography>
                                                            <Typography variant="body2" style={{ color: "#FF0000" }}>
                                                                Days Overdue
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>


                                ) : (
                                    <Grid item xs={12} style={{ padding: 14 }}>
                                        <Typography variant="subtitle1" style={{ fontSize: "20px" }}>
                                            Calibration Details
                                        </Typography>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} md={4}>
                                                <Paper
                                                    elevation={2}
                                                    style={{
                                                        paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px",
                                                        backgroundColor: "#FFFFFF",
                                                        border: "1px solid #E5E7EB",
                                                        height: "172px",
                                                        borderRadius: "10px"
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        color="secondary"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <CalendarTodayRoundedIcon fontSize="small" style={{ marginRight: 4 }} />
                                                        Last Calibrated
                                                    </Typography>

                                                    <Typography
                                                        variant="h6"
                                                        style={{
                                                            color: "#800280",
                                                            fontWeight: "bold",
                                                            fontSize: "24px", marginTop: "30px"
                                                        }}
                                                    >
                                                        {calibrationDataResponse?.last_calibrated_date
                                                            ? formatDate(calibrationDataResponse.last_calibrated_date)
                                                            : "--"}

                                                    </Typography>

                                                    <Typography variant="body2" color="textSecondary">
                                                        {calibrationDataResponse?.calibration_days} days ago
                                                    </Typography>
                                                </Paper>
                                            </Grid>


                                            <Grid item xs={12} md={4}>
                                                <Paper
                                                    elevation={4}
                                                    style={{ paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#EFFDF4", border: "1px solid #B9F8CF", height: "172px", borderRadius: "10px" }}
                                                >
                                                    <Typography variant="body2" style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: "#008000"
                                                    }}>
                                                        <ScheduleRoundedIcon fontSize="small" style={{ marginRight: "5px" }} />Next Calibration Due
                                                    </Typography>
                                                    <Typography variant="h6" style={{ color: "#008000", fontWeight: "bold", fontSize: "24px", marginTop: "30px" }}>
                                                        {calibrationDataResponse?.next_calibration_date
                                                            ? formatDate(calibrationDataResponse.next_calibration_date,)
                                                            : "--"}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        Calibration up to date
                                                    </Typography>
                                                </Paper>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <Paper
                                                    elevation={2}
                                                    style={{ paddingTop: "26px", paddingBottom: "26px", paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#FFFFFF", border: "1px solid #B9F8CF", height: "172px", borderRadius: "10px" }}
                                                >
                                                    <Typography variant="body2" style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: "#008000"
                                                    }} >
                                                        <CheckCircleOutlineRoundedIcon fontSize="small" style={{ marginRight: "5px", color: "#008000" }} />  Days to Next Calibration
                                                    </Typography>
                                                    <Typography variant="h6" style={{ color: "#008000", fontWeight: "bold", fontSize: "24px", marginTop: "30px" }}>
                                                        {calibrationDataResponse?.days_to_next_calibration ?? "--"}
                                                    </Typography>
                                                    <Typography variant="body2" style={{ color: "#008000" }}>
                                                        Days Remaining
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                )
                            )
                        }
                    </Grid>



                </Grid >


                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                    <DialogTitle>Extend Calibration</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" style={{ marginBottom: 16 }}>
                            Please select a new calibration due date and optionally provide a reason.
                        </Typography>
                        <TextField
                            label="New Calibration Date"
                            type="date"
                            fullWidth
                            value={newDate}
                            onChange={(e) => setNewDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            style={{ marginBottom: 16 }}
                        />
                        <TextField
                            label="Reason"
                            fullWidth
                            multiline
                            rows={3}
                            variant="outlined"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ backgroundColor: "#800280" }}
                            onClick={handleExtendSubmit}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </>


        )
    );

};
